import { Avatar, Box, Chip, Stack, SxProps, Typography } from "@mui/material";
import { FC } from "react";
import { thumbnailService } from "../../../Core/Api/services";
import { ActivityKind } from "../../../Core/Api/Types/activity-kind";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import AssetThumbnail from "../../Misc/AssetThumbnail";

export interface ActivityContextProps {
  assetType?: ObjectType;
  assetLayer?: ObjectLayer;
  activityKind: ActivityKind;
  title: string;
  subtitle?: string;
  label?: string;
  detail: string;
  resId: number;
  sxLeft?: SxProps;
}

const ActivityContext: FC<ActivityContextProps> = (props) => {
  const { title, detail, label, assetType, assetLayer, sxLeft = {} } = props;

  return (
    <Stack spacing={3} direction="row" alignItems="flex-start" justifyContent="space-between" mb={1}>
      <Box sx={{ flexGrow: 1, ...sxLeft }}>
        <Typography mb={0.5} variant="body2">
          {title}
          {label && label !== "Unknown" && (
            <Chip label={label} size="micro" color="primary" variant="outlined" component="span" sx={{ ml: 1 }} />
          )}
        </Typography>
        <Box sx={{ color: "text.tier" }}>
          {assetLayer !== ObjectLayer.Title && <Typography variant="body2">{detail}</Typography>}
          {assetLayer === ObjectLayer.Title && <Chip label={detail} size="micro" />}
        </Box>
      </Box>

      {assetLayer && assetType && assetLayer !== ObjectLayer.Title && (
        <AssetThumbnail type={assetType} sx={{ flexShrink: 0 }} />
      )}
      {assetLayer && assetType && assetLayer === ObjectLayer.Title && (
        <Avatar
          src={thumbnailService.GetObjectPosterUrl(props.resId)}
          sx={{ width: 36, height: 36, borderRadius: "3px" }}
        />
      )}
    </Stack>
  );
};

/*const BoxIcon = styled(Box, { shouldForwardProp: (prop) => prop !== "size" })<{
  size?: string;
}>(({ theme, size }) => ({
  padding: "14px",
  borderRadius: theme.shape.borderRadius,
  flexShrink: 0,
  width: "56px",
  height: "56px",
  svg: {
    width: "28px",
    height: "28px",
  },
  ...(size === "small" && {
    padding: "8px",
    width: "40px",
    height: "40px",
    borderRadius: "3px",
    svg: {
      width: "24px",
      height: "24px",
    },
  }),
}));*/

export default ActivityContext;
